import { Organization } from '../objects/Organization';
import { ResourceEndpoint } from './ResourceEndpoint';

export class OrganizationEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, Organization);
    }

    removeWageGroup(organizations) {
        var dst = this.url + '/removewagegroup';
        var items = organizations.map(x => ({
            Id: x.Id,
            RowVersion: x.RowVersion
        }));
        return this._api.postVoid(dst, { Items: items });
    }
}
